/* eslint-disable no-param-reassign */
import axios from 'axios';
// import Vuex from 'vuex';
import qs from 'qs';
import router from '../router/index';
import BASEURL from '../config/configBaseURL';
import store from '../store';

const axiosDefaultOptions = {
  // `method` 是创建请求时使用的方法
  method: 'post', // default
  // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
  // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
  baseURL: BASEURL.BASE_USER_URL + '/mobilegw-userCenter', // 新环境
  // baseURL: '/mobilegw', // 开发调试
  // `url` 是用于请求的服务器 URL
  url: '/gateway',
  // `headers` 是即将被发送的自定义请求头
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  // headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
  // `data` 是作为请求主体被发送的数据
  // data: {

  // },
  // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
  timeout: 10000,
  withCredentials: true,
  // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: 'json', // 默认的
  // `maxContentLength` 定义允许的响应内容的最大尺寸
  maxContentLength: 20000,
  // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
  validateStatus(status) {
    return status >= 200 && status < 300; // 默认的
  }
};

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // if (localStorage.token) {
    //   config.headers.Authorization = localStorage.token;
    // }
    if (store.state.token) {
      config.headers.token = store.state.token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.resultStatus === 2000) {
      // 会话超时 需要重新登录
      localStorage.removeItem('token');
      router.push('/login');
    }
    if (response.data.code == '401' || response.data.code == '402') {
      //token解析失败
      store.commit('del_token');
      router.push({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
      });
    }
    return response;
  },
  error => {
    // if (error.response) {
    //   switch (error.response.data.code) {
    //     case 401:
    //     this.$store.commit('del_token');
    //     router.push({
    //       path: '/login',
    //       query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
    //     })
    //     break;
    //   }
    // }
    return Promise.reject(error.response.data);
  }
);

const Axios = {
  /**
   * 全局配置的url,导出接口使用
   * */
  getBaseURL() {
    const NORMAL_URL = BASEURL.BASE_USER_URL + '/mobilegw-userCenter'; //新环境
    return NORMAL_URL;
  },

  request(datas) {
    const tDatas = datas;
    if (tDatas.data && tDatas.data.requestData) {
      tDatas.data.requestData = JSON.stringify(tDatas.data.requestData);
    }
    // console.log(Object.assign({}, axiosDefaultOptions, tDatas))
    return axios.request(Object.assign({}, axiosDefaultOptions, tDatas));
  },
  requestForm(datas) {
    const customOptions = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    return axios.request(Object.assign({}, axiosDefaultOptions, customOptions, datas));
  },
  requestWWWForm(datas) {
    const customOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    };
    const oDatas = datas;
    const d = {
      ...datas.data,
      ...axiosDefaultOptions.data
    };
    if (datas.data) {
      d.requestData = JSON.stringify(datas.data.requestData);
    }
    // d = qs.stringify(d);
    oDatas.data = qs.stringify(d);
    return axios.request(Object.assign({}, axiosDefaultOptions, oDatas, customOptions));
  },
  get(api, data, cb) {
    axios
      .get(api, data)
      .then(cb)
      .catch(err => {
        console.log(err);
      });
  },
  post(api, data, cb) {
    axios
      .post(api, data)
      .then(cb)
      .catch(err => {
        console.log(err);
      });
  }
};
export default Axios;
